import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';

import { BadgeModel, PriceViewModel } from 'models/common';
import { PriceBreakDownDetailsViewModel, RecentlyViewedModel } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';
import { UitkLink } from 'uitk-react-link';
import { UitkPrimaryButton } from 'uitk-react-button';

import { DoubleLink } from 'components/common/media/double-link';
import { Price } from 'components/common/pricing/price';
import { TargetableLink } from 'components/common/targetable-link';

export interface PriceAndSupportingMessagesContainerProps {
  secondaryCardMessage?: string;
  price?: PriceViewModel;
  supportingMessages?: string[];
  viewSmall: boolean;
  wrapPrice: boolean;
  priceFontWeight: string;
  hotelId?: number;
  secondary?: BadgeModel;
  recentlyViewed?: RecentlyViewedModel;
  isDatelessPdp?: boolean;
  lodgingPriceBreakDown?: PriceBreakDownDetailsViewModel;
  infositeUrl?: string;
  excludePriceBreakDownLink?: boolean;
  history?: {
    push: (submitUrl: string) => void;
  };
}

export const PriceAndSupportingMessagesContainer: React.FunctionComponent<PriceAndSupportingMessagesContainerProps> = ({
  secondaryCardMessage,
  supportingMessages,
  price,
  viewSmall,
  wrapPrice,
  priceFontWeight,
  hotelId,
  secondary,
  recentlyViewed,
  isDatelessPdp,
  infositeUrl,
  excludePriceBreakDownLink,
  lodgingPriceBreakDown
}) => {
  const ButtonTracked = ClickTracker(UitkPrimaryButton);
  const buttonLabel = lodgingPriceBreakDown && lodgingPriceBreakDown.ctaLabel;
  const extendedChildActions = (options: any): React.ReactNode => (
    <TargetableLink>
      <UitkLink inline={false} className="all-x-padding-four">
        <DoubleLink to={infositeUrl}>
          <ButtonTracked
            isFullWidth={true}
            rfrr="PriceBreakDown.ViewHotel"
            linkName={buttonLabel}
            data-stid="priceBreakDown-view-hotel"
            {...(options || {})}
          >
            {buttonLabel}
          </ButtonTracked>
        </DoubleLink>
      </UitkLink>
    </TargetableLink>
  );

  const priceCommonProps = {
    price,
    hotelId,
    priceFontWeight,
    recentlyViewed,
    messages: supportingMessages,
    lodgingPriceBreakDown,
    childActions: buttonLabel ? extendedChildActions : null,
    excludePriceBreakDownLink
  };

  if (isDatelessPdp) {
    return null;
  }
  if (viewSmall) {
    return (
      <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink listing__pricing">
        <ErrorBoundary label="hotel.search.listing.price">
          {secondaryCardMessage && (
            <span className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900">{secondaryCardMessage}</span>
          )}
          <Price className="listing__price" wrapPrice={wrapPrice} {...priceCommonProps} />
        </ErrorBoundary>
      </div>
    );
  } else {
    return (
      <div className="uitk-cell all-x-gutter-two uitk-type-right all-cell-shrink">
        {secondary && (secondary.text || secondary.icon) && <UitkBadge theme={UitkBadgeTheme[secondary.theme]} text={secondary.text} />}
        {secondaryCardMessage && (
          <div className="secondary-card-message uitk-type-200 uitk-type-medium pwa-theme--grey-900 all-t-margin-one">
            {secondaryCardMessage}
          </div>
        )}{' '}
        <ErrorBoundary label="hotel.search.listing.price">
          <Price className="listing__price all-t-padding-half" {...priceCommonProps} />
        </ErrorBoundary>
      </div>
    );
  }
};
